import React from "react";
import OrganisationTeam from "../Components/team/organisationteam";
import LeadersSection from "../Components/leaders/LeadersSection";
import SingleCenteredImage from "../Components/team/SingleCenteredImage";
import AboutADMKSection from "../Components/leaders/AboutADMKSection";

export default function RegistrationPage() {
  return (
    <>
    <LeadersSection />
    <AboutADMKSection />
    <SingleCenteredImage />
    <OrganisationTeam />
    </>
  );
}
